<template>
  <BlBackdrop
    title="Session launch before schedule"
    :footer="false"
    @backdrop-close="$emit('close-modal')"
  >
    <div class="px-8 pb-8 w-160 flex flex-col gap-4">
      <div>
        <BlTextBody2
          text="This session is scheduled for:"
          class="text-slate-800"
        />
      </div>
      <div class="flex items-center gap-2 mb-4">
        <div class="w-25 flex-shrink-0 rounded shadow-md">
          <div
            class="h-7 flex items-center justify-center rounded-t bg-lime-200"
          >
            <BlTextBody2 text="Scheduled" class="text-lime-700" />
          </div>
          <div
            class="h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
          >
            <BlTextTitle4
              :text="displayDate(sessionAppointment.date, 'DD')"
              class="text-lime-700"
            />
            <BlTextBody2
              :text="displayDate(sessionAppointment.date, 'MMMM')"
              class="text-lime-600"
            />
          </div>
        </div>
        <div class="flex flex-col gap-1 px-2">
          <div class="flex items-center gap-2">
            <BlIcon icon="user" color="slate-6" class="h-4 w-4" />
            <BlTextBody2 v-if="!sessionAppointment.user" text="-" />
            <BlTextBody2
              v-else
              :text="sessionAppointment.user.name || 'Deleted user'"
              :class="{ 'italic ': !sessionAppointment.user.name }"
            />
          </div>
          <div class="flex items-center gap-2">
            <BlIcon icon="clock-outline" color="slate-6" class="h-4 w-4" />
            <BlTextBody2
              :text="
                `${sessionAppointment.start_time_string} - ${sessionAppointment.end_time_string}`
              "
              class="text-slate-800"
            />
          </div>
          <div v-if="sessionAppointment.room" class="flex items-center gap-2">
            <BlIcon icon="door" color="slate-6" class="h-4 w-4" />
            <BlTextBody2
              :text="sessionAppointment.room.name"
              class="text-slate-800"
            />
          </div>
        </div>
      </div>
      <div>
        <BlTextBody2
          text="Are you sure you want to start the session now?"
          class="text-slate-800"
        />
      </div>
      <div class="flex items-center justify-end gap-4">
        <BlInputButton
          type="plain"
          label="Cancel"
          @clicked="$emit('close-modal')"
        />
        <BlInputButton label="Proceed" @clicked="$emit('on-submit')" />
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import moment from "moment";

import BlTextTitle4 from "../../BlTextTitle4.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlIcon from "../../BlIcon.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlBackdrop from "../../BlBackdrop.vue";

export default {
  name: "LaunchBeforeTheTimeModal",
  components: {
    BlTextTitle4,
    BlTextBody2,
    BlIcon,
    BlInputButton,
    BlBackdrop
  },
  props: {
    sessionAppointment: { type: Object, required: true }
  },
  methods: {
    displayDate(date, format) {
      if (!date) return "";
      return moment(date).format(format);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sessions/draft/LaunchBeforeTheTimeModal.vue